import { useEffect, useState } from "react";

const navLinks = [
  { id: "flash", label: "实时快讯" },
  { id: "today", label: "今日更新" },
  { id: "hot", label: "吃瓜热榜" },
  { id: "community", label: "讨论区" },
  { id: "trust", label: "信源与规范" },
  { id: "faq", label: "常见问题" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur border-b border-background-200/70"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex h-16 md:h-20 items-center justify-between gap-4">
          {/* brand */}
          <a href="#top" className="flex items-center gap-2.5 shrink-0 group">
            <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-lg transition-transform group-hover:rotate-6">
              <i className="ri-water-flash-line"></i>
            </span>
            <span className="text-xl font-black tracking-tight text-foreground-950">
              擦边吃瓜
            </span>
          </a>

          {/* nav (desktop) */}
          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-700 rounded-md hover:bg-background-100 transition whitespace-nowrap"
              >
                {l.label}
              </a>
            ))}
          </nav>

          {/* right actions */}
          <div className="flex items-center gap-2 md:gap-3">
            <a
              href="#today"
              className="hidden sm:inline-flex items-center gap-2 rounded-md border border-background-300/70 bg-background-50/70 px-3 py-2 text-sm text-foreground-700 hover:border-primary-300 transition whitespace-nowrap"
            >
              <i className="ri-search-line text-sm"></i>
              搜旧瓜
            </a>
            <a
              href="#today"
              className="inline-flex items-center gap-1.5 rounded-md bg-primary-500 text-background-50 px-3.5 py-2 text-sm font-semibold hover:bg-primary-600 transition whitespace-nowrap"
            >
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full rounded-full bg-accent-200 animate-ping"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-accent-100"></span>
              </span>
              抢鲜看新瓜
            </a>
            {/* hamburger */}
            <button
              type="button"
              aria-label="打开导航"
              className="lg:hidden w-10 h-10 rounded-md bg-background-100 text-foreground-800 flex items-center justify-center cursor-pointer"
              onClick={() => setMenuOpen((v) => !v)}
            >
              <i className={`${menuOpen ? "ri-close-line" : "ri-menu-line"} text-xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {/* mobile panel */}
      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-b border-background-200/70 px-4 pb-4">
          <nav className="grid grid-cols-2 gap-2">
            {navLinks.map((l) => (
              <a
                key={l.id}
                href={`#${l.id}`}
                onClick={() => setMenuOpen(false)}
                className="px-3 py-2.5 rounded-md bg-background-100 text-sm text-foreground-800 hover:bg-primary-50 hover:text-primary-700 transition"
              >
                {l.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}